import {
  ColDef,
  ICellRendererParams,
  ValueFormatterParams,
} from '@ag-grid-community/core'

import EditButtonCellRenderer from './editButtonCellRenderer'
import { PageAccess } from 'types/user'
import { PAGE_USER_MGMT, ROLES } from 'utils/constants'

export const getColumns = ({
  isEditor,
  page,
}: {
  isEditor: boolean
  page: number
}) => {
  return [
    {
      headerName: 'ID',
      field: 'uuid',
      valueFormatter: (params: ValueFormatterParams) => {
        return (params.node?.rowIndex as number) + 1 + page
      },
    },
    { headerName: 'Employee ID', field: 'empId' },
    { headerName: 'First Name', field: 'firstName' },
    { headerName: 'Last Name', field: 'lastName' },
    { headerName: 'Email', field: 'email' },
    {
      headerName: 'Status',
      field: 'isActive',
      cellRenderer: (params: ICellRendererParams) => {
        return params.value ? 'Active' : 'Inactive'
      },
    },
    {
      hide: !isEditor,
      field: 'editCell',
      headerName: '',
      cellRenderer: (params: ICellRendererParams) => (
        <EditButtonCellRenderer isEditor={isEditor} params={params} />
      ),
    },
  ] as ColDef[]
}

/**
 * PREFIX for Page access fields
 */
export const PAGE_ACCESS_KEY_PREFIX = 'PAGE_'

/**
 * Will remove the page keys and add the pageAccess array with page and isEditor
 */
export const formatObjectWithPageAccess = (
  userData: Record<string, unknown>,
) => {
  const user = { ...userData }
  const pageAccessArray: PageAccess[] = []

  // Will get all keys of the user object
  Object.keys(user).forEach((key: string) => {
    // Handle the array of page access, by adding only page related keys
    if (key.startsWith(PAGE_ACCESS_KEY_PREFIX)) {
      // Page id as per the app structure
      const pageId = key.replace(PAGE_ACCESS_KEY_PREFIX, '')

      // User management is handled sperately, and the page with no access is not added to array
      if (user[key] !== null && pageId !== PAGE_USER_MGMT.id) {
        pageAccessArray.push({
          page: pageId,
          isEditor: (user[key] as boolean) ?? false,
        })
      }

      // User management page access is handled, will add it in array only if the role is super admin
      if (pageId === PAGE_USER_MGMT.id && user.role === ROLES.SUPER_ADMIN) {
        pageAccessArray.push({
          page: PAGE_USER_MGMT.id,
          isEditor: true,
        })
      }

      // Delete the key from root
      delete user[key]
    }
  })

  user.pageAccess = pageAccessArray
  return user
}
